import $ from 'jquery';

export const elements = {
    call    : '.js-MainNavigation-Mobile-Call',
    holder  : '.js-MainNavigation-Mobile-Holder',
    item    : '.js-MainNavigation-Item',
    submenu : '.js-MainNavigation-Submenu',
    submenuCall: '.js-MainNavigation-Item > a',
    searchCall: '.c-navigation-main-search-call',
    searchHolder: '.c-navigation-main-search-field'
};

export const onClick = function() {

    const searchIsExpanded = $(elements.searchHolder).hasClass('fn-visible');
    searchIsExpanded && $(elements.searchCall).trigger('click');

    $(elements.holder).toggleClass('fn-visible');
    $(elements.call).toggleClass('fn-visible');
};

const toggleSearchBar = function() {

    if ($(window).width() > 767) {
      return;
    }

    const menuIsExpanded = $(elements.holder).hasClass('fn-visible');

    if (menuIsExpanded) {
      $(elements.holder).removeClass('fn-visible');
      $(elements.call).removeClass('fn-visible');
    }
};

const toggleMenuItem = function(event) {

  if ($(window).width() > 767) {
    return;
  }

  const $this = $(this);
  const left = $this.offset().left;
  const width = $this.outerWidth();
  const mouseX = event.originalEvent.pageX;

  if (width - mouseX < 50) {
    event.preventDefault();

    const item = $(this).parent(elements.item);
    const submenu = item.find(elements.submenu);
    const isActive = submenu.hasClass('fn-active');

    $(elements.item).removeClass('fn-active');
    $(elements.submenu).removeClass('fn-active');

    if (!isActive) {
      item.addClass('fn-active');
      submenu.addClass('fn-active');
    }
  }
};

export default {
  init(params) {
    params.$document.on('click', elements.call, onClick);
    params.$document.on('click', elements.submenuCall, toggleMenuItem);
    params.$document.on('click', elements.searchCall, toggleSearchBar);
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/menu/mobile.js